export function sectionNav() {
  const bar     = document.getElementById("section-nav-bar");
  const toggle  = document.getElementById("section-nav-toggle");
  const menu    = document.getElementById("section-nav-menu");
  const label   = document.getElementById("section-nav-label");
  const chevron = document.getElementById("section-nav-chevron");

  if (!bar || !toggle || !menu) return;

  function getHeaderOffset() {
    const header = document.querySelector("header");
    return header ? header.offsetHeight : 0;
  }

  const sections      = window.sectionNavData || [];
  const showThreshold = 100; // px scrolled before bar appears
  const bottomPadding = 80;  // px from document bottom to hide bar (before footer)
  let   ticking       = false;

  // ── Show / hide bar on scroll ─────────────────────────────────────────────

  function updateBarVisibility() {
    const scrollBottom = window.scrollY + window.innerHeight;
    const docHeight    = document.documentElement.scrollHeight;

    const pastThreshold = window.scrollY > showThreshold;
    const nearBottom    = scrollBottom >= docHeight - bottomPadding;
    const visible       = pastThreshold && !nearBottom;

    if (visible) {
      bar.classList.remove("opacity-0", "translate-y-4", "pointer-events-none");
    } else {
      bar.classList.add("opacity-0", "translate-y-4", "pointer-events-none");
      // Close dropdown when bar hides
      if (menu.classList.contains("open-menu")) {
        menu.style.maxHeight = "0";
        menu.classList.remove("open-menu");
        toggle.classList.remove("active");
        if (chevron) chevron.style.transform = "";
      }
    }
  }

  function onScroll() {
    // Close dropdown immediately on any scroll
    if (menu.classList.contains("open-menu")) {
      menu.style.maxHeight = "0";
      menu.classList.remove("open-menu");
      toggle.classList.remove("active");
      if (chevron) chevron.style.transform = "";
    }

    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(() => {
        updateBarVisibility();
        updateActiveSection();
        ticking = false;
      });
    }
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", updateBarVisibility, { passive: true });
  updateBarVisibility();

  // ── Dropdown (mirrors case-study-scroll.js exactly) ──────────────────────

  function toggleMenu() {
    const isOpen = menu.classList.toggle("open-menu");
    toggle.classList.toggle("active");

    if (isOpen) {
      menu.style.maxHeight = menu.scrollHeight + "px";
    } else {
      menu.style.maxHeight = "0";
    }

    if (chevron) {
      chevron.style.transform = isOpen ? "rotate(180deg)" : "";
    }
  }

  toggle.addEventListener("click", function (e) {
    toggleMenu();
    e.stopPropagation();
  });

  document.addEventListener("click", function (e) {
    if (!toggle.contains(e.target)) {
      if (menu.classList.contains("open-menu")) {
        menu.style.maxHeight = "0";
        menu.classList.remove("open-menu");
        toggle.classList.remove("active");
        if (chevron) chevron.style.transform = "";
      }
    }
  });

  // Dropdown close on scroll is handled inside onScroll → updateBarVisibility.

  // Smooth scroll with offset for the fixed header.
  menu.querySelectorAll(".section-nav-link").forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const target = document.getElementById(link.dataset.sectionId);
      if (target) {
        const top =
          target.getBoundingClientRect().top +
          window.scrollY -
          getHeaderOffset();
        window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
        history.pushState(null, null, link.getAttribute("href"));
      }
      // Close the menu after click
      menu.style.maxHeight = "0";
      menu.classList.remove("open-menu");
      toggle.classList.remove("active");
      if (chevron) chevron.style.transform = "";
    });
  });

  // ── Scrollspy: update label to current section ────────────────────────────

  function updateActiveSection() {
    if (!label || sections.length === 0) return;

    const triggerY = window.scrollY + window.innerHeight * 0.35;
    let active = sections[0];

    for (const section of sections) {
      const el = document.getElementById(section.id);
      if (el && el.offsetTop <= triggerY) {
        active = section;
      }
    }

    if (label.textContent !== active.label) {
      label.textContent = active.label;
    }
  }

  updateActiveSection();
}
